import { Address } from 'types';
import { AddressActions } from 'types/store/actions/addresses';
import { AddressActionTypes } from 'types/store/actions/constants';

// eslint-disable-next-line import/prefer-default-export
export const fetchSuccess = (address: Address): AddressActions => ({
  type: AddressActionTypes.FETCH_SUCCESS,
  payload: address,
});
